import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-heading font-bold text-background-50 mb-4">
              韩漫网
            </h4>
            <p className="text-sm text-background-50/60 leading-relaxed">
              韩漫网 — 发现韩漫之美
            </p>
            <p className="text-sm text-background-50/60 leading-relaxed mt-2">
              高质量韩国漫画在线阅读平台，每日更新最新漫画资源。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">分类浏览</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/romance" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">浪漫爱情</Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">奇幻冒险</Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">热血动作</Link>
              </li>
              <li>
                <Link to="/category/drama" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">都市剧情</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4">
              法律信息
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">使用条款</a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">DMCA声明</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            © 2026 韩漫网 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500/30 transition-colors cursor-pointer">
              <i className="ri-wechat-line text-background-50/70 text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500/30 transition-colors cursor-pointer">
              <i className="ri-weibo-line text-background-50/70 text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500/30 transition-colors cursor-pointer">
              <i className="ri-bilibili-line text-background-50/70 text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}